"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseError = void 0;
// TODO: Generalize this. See https://github.com/usecannon/cannon/blob/main/packages/builder/src/error/index.ts
function parseError(error) {
    try {
        if (error.cause?.data) {
            return error.cause?.data;
        }
        if (error.cause?.cause?.data) {
            return error.cause?.cause?.data;
        }
        if (error.cause?.cause?.cause?.data) {
            return error.cause?.cause?.cause?.data;
        }
        if (error.cause?.cause?.error?.data) {
            return error.cause?.cause?.error?.data;
        }
        if (error.cause?.cause?.cause?.error?.data) {
            return error.cause?.cause?.cause?.error?.data;
        }
    }
    catch (err) {
        console.error("exception in erc7412 error parser:", err);
    }
    // rethrow the error (and log it so we can see the original)
    console.error("got unknown error in erc7412 parse", error);
    throw error;
}
exports.parseError = parseError;
//# sourceMappingURL=parseError.js.map